module.exports = __webpack_public_path__ + "img/caidaoApp-2.a3c05a5c.png";